import { render, staticRenderFns } from "./TermsOfServiceModal.vue?vue&type=template&id=61caad9f&scoped=true"
import script from "./TermsOfServiceModal.vue?vue&type=script&lang=js"
export * from "./TermsOfServiceModal.vue?vue&type=script&lang=js"
import style0 from "./TermsOfServiceModal.vue?vue&type=style&index=0&id=61caad9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../Desktop/Trabajo/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61caad9f",
  null
  
)

export default component.exports